import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Button from '../../elements/Button'
const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
              DHAIRYA KAPOOR
              +91 9855767900

        </li>
        {/* <li>
            EASETHEBUILD@GMAIL@GMAIL.COM
        </li> */}

        {/* <li>
          <Link to="/about-us/">About us</Link>
        </li>
        <li>
          <Link to="/faqs/">FAQ's</Link>
        </li>
        <li>
          <Link to="/support/">Support</Link>
        </li> */}
      </ul>
      EASETHEBUILD@GMAIL.COM
    </nav>
  );
}

export default FooterNav;